module.exports = __webpack_public_path__ + "static/rendition-200h-example-4a1359f4471bc057093a4d3c52d09761.gif";